import(/* webpackMode: "eager" */ "/vercel/path0/apps/hsiyc/app/not-found.tsx");
